export default window._cmsContent['common/cookie-modal']